import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLink = () => {
  return (
    <g>
      <path d="M9.43 1.1a3.843 3.843 0 0 1 5.388.004l.1.103a3.965 3.965 0 0 1 .037 5.404l-.14.145-2.69 2.656a3.843 3.843 0 0 1-5.387-.003l-.1-.104a.744.744 0 0 1 .04-1.06.767.767 0 0 1 1.073.041l.06.062a2.311 2.311 0 0 0 3.125.108l.114-.106 2.69-2.656c.922-.91.986-2.355.175-3.341l-.148-.166-.023-.022a2.311 2.311 0 0 0-3.124-.108l-.115.105-2.69 2.657a.767.767 0 0 1-1.074 0 .744.744 0 0 1-.069-.985l.068-.077L9.43 1.1zM3.874 6.588a3.843 3.843 0 0 1 5.388.003l.1.104a.744.744 0 0 1-.04 1.06.767.767 0 0 1-1.073-.041l-.06-.062a2.311 2.311 0 0 0-3.125-.108l-.114.106-2.69 2.656a2.477 2.477 0 0 0-.175 3.341l.148.166.023.022a2.311 2.311 0 0 0 3.124.108l.115-.105 2.69-2.657a.767.767 0 0 1 1.074 0c.272.27.295.691.069.985l-.068.077L6.57 14.9a3.843 3.843 0 0 1-5.388-.004l-.1-.103a3.965 3.965 0 0 1-.037-5.404l.14-.145 2.69-2.656z" />
    </g>
  );
};

export default withIcon(IconLink);
